const initialState = {
  campaigns: [],
  campaign: null,
  lastCreatedCampaign: null,
  selectedCampaign: null,
  totalPages: 1,
  totalCount: 0,
  size: 10,

  fetchingCampaigns: false,
  errorFetchingCampaigns: null,
  fetchingCampaign: false,
  errorFetchingCampaign: null,
  creatingCampaign: false,
  errorCreatingCampaign: null,
  updatingSampleMessages: false,
  errorUpdatingSampleMessages: null,
  updatingContentAttributes: false,
  errorUpdatingContentAttributes: null,
  deletingCampaign: false,
  errorDeletingCampaign: null,
  qualifyingBrand: false,
  errorQualifyingBrand: null,
  qualification: null,
  fetchingNumbers: false,
  numbersMap: {},
  numbersPage: 1,
  numbersCount: 0,
  numbersPageSize: 20,
  handlingNumberLink: false,
  errorHandlingNumberLink: undefined,
  linkedCampaigns: {},
  fetchingLinkedNumbers: false,

  sampleMessagesMin: 2,
  qualified: true,
  contentAttributesRequired: {},
  
  campaignInCreationUseCase: null,
};

export default initialState;
